import { createRouter, createWebHistory } from 'vue-router';
import routes from '@/router/routes';
import { APP_CONFIG } from '@/constants';

const base =
  APP_CONFIG.publicUrl.indexOf('://') !== -1
    ? new URL(APP_CONFIG.publicUrl).pathname
    : APP_CONFIG.publicUrl;

const router = createRouter({
  history: createWebHistory(base),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    return { left: 0, top: 0 };
  },
  routes,
});

export default router;
